import React, {memo} from 'react';
import {Flex, Title} from '@priority-software/priority-style-react';
import {ToDoListWidget} from '../../../../features/ToDoList/components/ToDoListWidget';
import {HomepageItemData} from '../../api';
import {PortletSettingsDropdown} from '../PortletSettingsDropdown/PortletSettingsDropdown';
import {removeItemFromHomepage} from '../../actions/dialogs';
import styles from './styles.module.scss';
import {openDateRangeDialog} from './utils';
import {WWWDBTODOLIST} from '../../constants';

type Props = HomepageItemData;

export const Portlet = memo((props: Props) => {
    const {exec, title, url, ename} = props;

    const openInWindow = () => {
        if (url) {
            window.open(url, '_blank');
        }
    };

    const onRemovePortlet = async () => {
        await removeItemFromHomepage(exec, title);
    };

    const renderContent = () => {
        if (ename === WWWDBTODOLIST) {
            return (
                <ToDoListWidget
                    props={{ex: exec, selector: ename}}
                    componentClasses={styles.widgetHeight}
                    onRemove={removeItemFromHomepage}
                />
            );
        }

        return (
            <>
                <Flex className={styles.header}>
                    <Title skin="h4" textColor="primary-700">
                        {title}
                    </Title>

                    <PortletSettingsDropdown
                        openInWindow={openInWindow}
                        removePortlet={onRemovePortlet}
                        openChooseDates={() => openDateRangeDialog(ename)}
                    />
                </Flex>

                <iframe src={url} style={{width: '100%', height: 250}} frameBorder={0} id={ename} />
            </>
        );
    };

    return <div className={styles.component}>{renderContent()}</div>;
});
